import React from 'react'
import utils from '../../utils';

function Pagination(props) {
    const next = props.next
    const previous = props.previous
    const isAdmin = props.isAdmin

    function changePage(page){
        props.changePageParam(page)
    }
    return (
        <div className='flex justify-center pt-5'>
            <div className="join border">
                {previous && (
                    <button 
                        onClick={() => changePage(utils.getPageValue(previous))}
                        className={isAdmin ? "join-item btn btn-neutral btn-outline btn-sm":"join-item btn"}>«</button>
                )}
                <button 
                    className={isAdmin ? "join-item btn btn-neutral btn-outline btn-sm":"join-item btn"}>Page {utils.getCurrentPage(previous, next)}</button>
                {next && (
                    <button
                        onClick={() => changePage(utils.getPageValue(next))}
                        className={isAdmin ? "join-item btn btn-neutral btn-outline btn-sm":"join-item btn"}>»</button>
                )}    
            </div>
        </div>
    )
}

export default Pagination